import { flushSync } from "react-dom";

let activeTransition;
let revision = 0;

export function changeTheme(update) {
  const currentRevision = ++revision;
  activeTransition?.skipTransition();
  activeTransition = undefined;
  let applied = false;
  const apply = () => {
    if (applied || currentRevision !== revision) return;
    applied = true;
    flushSync(update);
  };
  const root = document.documentElement;
  if (
    !document.startViewTransition ||
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  ) {
    root.classList.remove("theme-transition");
    apply();
    return;
  }

  root.classList.add("theme-transition");
  try {
    const transition = document.startViewTransition(apply);
    activeTransition = transition;
    transition.ready?.catch(() => {});
    // A skipped visual transition must still allow the preference to update.
    transition.updateCallbackDone.catch(apply);
    const cleanup = () => {
      if (activeTransition !== transition) return;
      activeTransition = undefined;
      root.classList.remove("theme-transition");
    };
    transition.finished.then(cleanup, cleanup);
  } catch {
    root.classList.remove("theme-transition");
    apply();
  }
}
